<template>
  <div class="download">
    <banner :img="imgurl" title="党的建设" />


 <div class="radionstyle">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/download">党建概况</el-menu-item>
            <el-menu-item index="/downloadone">党建工作</el-menu-item>
            <el-menu-item index="/downloadtwo">群团工作</el-menu-item>
          </el-menu>
        </div>



  <div class="djtitle">
        <div class="imgtitle">
          <img src="../assets/img/dj.png" height="300" width="400"/>
        </div>
        <div class="texttitle">
<!-- <el-input
  type="textarea"
  :autosize="{ minRows: 2, maxRows: 4}"
  placeholder="请输入内容"
  v-model="textarea2">
</el-input> -->
<h3 style="margin-top:20px;margin-left:10px">{{textarea1}}</h3>
<h4 style="margin-top:20px;line-height:20px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{textarea2}}</h4>

        </div>
  </div>

  <div class="djfooter">
    <div class="footertitle">

<h3 style="margin-top:20px;margin-left:10px">{{textarea0}}</h3>


        </div>



        <div class="footerimg">
          <img src="../assets/img/dg2.jpg" />
        </div>
    
  </div>




  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      textarea0:"学党史：    永远跟党走",
      textarea1:"中共贵州永贵机电机制修有限公司总支委会",
      textarea2:"    以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大和十九届二中、三中、四中、五中全会及中央经济工作会议精神，按照省委十届十二次全会及省委经济工作会议部署，坚持稳中求进工作总基调，立足新发展阶段，贯彻新发展理念，融入新发展格局，以高质量发展为主题，以改革创新为根本动力，做实做精做优企业为导向，与职工共享企业发展成果为目的，强化战略思维和系统观念，统筹发展和安全，着力打好深化改革、对标提升和风险化解三大攻坚战，以高质量党建引领企业高质量发展，确保十四五开好局、起好步，以优异成绩庆祝建党100周年。",
      router: true,
      defaultActive: "/",
      imgurl: require("../assets/img/list_bg.png"),
    };
  },
   methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss" scoped>
.radionstyle{

  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
}
.el-radionstyle-demo {
  background-color: rgb(163, 172, 166);
  opacity: 0.4;
}
.djtitle{
  align-content: center;
  height: 350px;
   width: 1240px;

  justify-content: stretch;
   margin: 0 auto;
   display: flex;
   .imgtitle{
  height: 300px;
  width: 400px;
  
  margin-top: 20px;
  margin-left: 20px;
}
.texttitle{
  line-height: 20px;
  height: 300px;
  width: 600px;
 
  margin-top: 20px;
  margin-left: 40px;
  font-size: 20px;
}
}
.djfooter{
   align-content: center;
   height: 650px;
   width: 99.9%;
   
   justify-content: stretch;
   margin: 0 auto;
 
   background-color: #eee;
   .footertitle{
       padding-top: 10px;
text-align: center;
margin-right: 1000px;
   }
   .footerimg{
     margin-top: 40px;
     text-align: center;
padding-right: 0px;
   }
}

</style>
